import React from 'react'
import DefaultSettingManagement from './abstract/DefaultSettingManagement'

import StyleAdmin from '../../../style/StyleAdmin'
import Window from '../../../../common/Window'
import Loading from '../../../../common/component/Loading'

class GetsugakuSetting extends DefaultSettingManagement {
  constructor (props) {
    super(props)
    this.state = {isLoaded: false, offset: false}
    this.systemSettingName = 'GetsugakuSetting'
  }
  onInsertGetsugakuSetting (offset) {
    offset = Number(offset)
    const GetsugakuSetting = this.getSettingData()
    const lastGetsugakuSetting = GetsugakuSetting[offset]
    const newToukyuuList = []
    lastGetsugakuSetting.toukyuuList.map((e) => {
      newToukyuuList.push(Object.assign({}, e))
    })
    GetsugakuSetting.splice(offset + 1, 0,
      {
        startMonth: lastGetsugakuSetting.endMonth,
        endMonth: lastGetsugakuSetting.endMonth + 500,
        toukyuuList: newToukyuuList
      }
    )
    this.setState({
      offset: offset + 1,
      GetsugakuSetting: GetsugakuSetting,
      GetsugakuSettingInputData: JSON.parse(JSON.stringify(GetsugakuSetting))
    })
  }
  onDeleteGetsugakuSetting (offset) {
    if (this.getSettingData().length > 1) {
      Window.confirm('この行を削除してもよろしいですか?', () => {
        offset = Number(offset)
        const GetsugakuSetting = this.getSettingData()
        GetsugakuSetting.splice(offset, 1)
        this.setState({
          offset: false,
          GetsugakuSetting: GetsugakuSetting,
          GetsugakuSettingInputData: JSON.parse(JSON.stringify(GetsugakuSetting))
        })
        Window.closeDialog()
      })
    }
  }
  onMoveUpGetsugakuSetting (offset) {
    offset = Number(offset)
    if (offset > 0) {
      const GetsugakuSetting = this.getSettingData()
      GetsugakuSetting.splice(offset - 1, 2, GetsugakuSetting[offset], GetsugakuSetting[offset - 1])
      this.setState({
        GetsugakuSetting: GetsugakuSetting,
        GetsugakuSettingInputData: JSON.parse(JSON.stringify(GetsugakuSetting))
      })
    }
  }
  onMoveDownGetsugakuSetting (offset) {
    offset = Number(offset)
    const GetsugakuSetting = this.getSettingData()
    if (offset < GetsugakuSetting.length - 1) {
      offset++
      GetsugakuSetting.splice(offset - 1, 2, GetsugakuSetting[offset], GetsugakuSetting[offset - 1])
      this.setState({
        GetsugakuSetting: GetsugakuSetting,
        GetsugakuSettingInputData: JSON.parse(JSON.stringify(GetsugakuSetting))
      })
    }
  }
  onSwitchTerm (offset) {
    this.setState({
      offset: offset
    })
  }
  changed (index, attributeName, e) {
    const GetsugakuSetting = this.state.GetsugakuSetting
    GetsugakuSetting[index][attributeName] = parseInt(e.target.value)
    this.setState({
      GetsugakuSetting: GetsugakuSetting
    })
  }
  onInsertToukyuuList (offset, index) {
    offset = Number(offset)
    index = Number(index)
    const GetsugakuSetting = this.getSettingData()
    GetsugakuSetting[offset].toukyuuList.splice(index + 1, 0,
      {
        kenkou: 0,
        nenkin: 0,
        izhou: GetsugakuSetting[offset].toukyuuList[index].miman,
        miman: 0
      }
    )
    this.setState({
      GetsugakuSetting: GetsugakuSetting,
      GetsugakuSettingInputData: JSON.parse(JSON.stringify(GetsugakuSetting))
    })
  }
  onDeleteToukyuuList (offset, index) {
    if (this.getSettingData().length > 1) {
      Window.confirm('この行を削除してもよろしいですか?', () => {
        offset = Number(offset)
        index = Number(index)
        const GetsugakuSetting = this.getSettingData()
        GetsugakuSetting[offset].toukyuuList.splice(index, 1)
        this.setState({
          GetsugakuSetting: GetsugakuSetting,
          GetsugakuSettingInputData: JSON.parse(JSON.stringify(GetsugakuSetting))
        })
        Window.closeDialog()
      })
    }
  }
  onMoveUpToukyuuList (offset, index) {
    offset = Number(offset)
    index = Number(index)
    if (index > 0) {
      const GetsugakuSetting = this.getSettingData()
      GetsugakuSetting[offset].toukyuuList.splice(index - 1, 2, GetsugakuSetting[offset].toukyuuList[index], GetsugakuSetting[offset].toukyuuList[index - 1])
      this.setState({
        GetsugakuSetting: GetsugakuSetting,
        GetsugakuSettingInputData: JSON.parse(JSON.stringify(GetsugakuSetting))
      })
    }
  }
  onMoveDownToukyuuList (offset, index) {
    offset = Number(offset)
    index = Number(index)
    const GetsugakuSetting = this.getSettingData()
    if (index < GetsugakuSetting[offset].toukyuuList.length - 1) {
      index++
      GetsugakuSetting[offset].toukyuuList.splice(index - 1, 2, GetsugakuSetting[offset].toukyuuList[index], GetsugakuSetting[offset].toukyuuList[index - 1])
      this.setState({
        GetsugakuSetting: GetsugakuSetting,
        GetsugakuSettingInputData: JSON.parse(JSON.stringify(GetsugakuSetting))
      })
    }
  }
  changeToukyuuData (offset, toukyuuIndex, attributeName, e) {
    const GetsugakuSetting = this.state.GetsugakuSetting
    const GetsugakuSettingInputData = this.state.GetsugakuSettingInputData
    let changedValue = e.target.value
    // 数値以外を除く
    changedValue = changedValue.replace(/[^0-9]/g, '')
    // input用データ(NaN表示防止)
    GetsugakuSettingInputData[offset].toukyuuList[toukyuuIndex][attributeName] = changedValue
    // 保存用データ（整数にする）
    GetsugakuSetting[offset].toukyuuList[toukyuuIndex][attributeName] = parseInt(changedValue)
    this.setState({
      GetsugakuSetting: GetsugakuSetting,
      GetsugakuSettingInputData: GetsugakuSettingInputData
    })
  }
  render () {
    if (!this.state.isLoaded) {
      return <Loading />
    }
    const getsugakuSetting = this.getSettingData()
    const yearMonthList = this.getYMList(60, 201501).reverse()
    const yearMonthListToShow = []
    yearMonthList.forEach(ym => {
      yearMonthListToShow.push(
        <option key={this.uuid()} value={ym.id}>{ym.name}</option>
      )
    })
    const getsugakuSettingToShow =
    getsugakuSetting.map((getsugaku, index, list) => {
      const isTop = (index === 0)
      const isBottom = (index === list.length - 1)
      const isOnlyOne = (list.length <= 1)
      return (
        <tr key={index}>
          <th className='kw-ds-no'>{index + 1}</th>
          <td><select value={getsugaku.startMonth} ref={'startMonth' + index} onChange={(e) => this.changed(index, 'startMonth', e)}>{yearMonthListToShow}</select></td>
          <td><select value={getsugaku.endMonth} ref={'endMonth' + index} onChange={(e) => this.changed(index, 'endMonth', e)}>{yearMonthListToShow}</select></td>
          <td className='kw-ds-getsugaku'><a onClick={this.onSwitchTerm.bind(this, index)}>編集</a></td>
          <td className='kw-ds-gyou-sousa-icons'>
            <span className='text-success'><i className='icon-plus-sign kw-pointer' onClick={this.onInsertGetsugakuSetting.bind(this, index)} /></span>
            <span className='text-error'><i className='icon-minus-sign' onClick={this.onDeleteGetsugakuSetting.bind(this, index)}
              style={isOnlyOne ? {color: 'gray', cursor: 'not-allowed'} : {color: 'rgb(185, 74, 72)', cursor: 'pointer'}} /></span>
            <span className='text-info'><i className='icon-circle-arrow-up' style={isTop ? {color: 'gray', cursor: 'not-allowed'} : {color: 'rgb(58, 135, 173)', cursor: 'pointer'}}
              onClick={this.onMoveUpGetsugakuSetting.bind(this, index)} /></span>
            <span className='text-info'><i className='icon-circle-arrow-down' style={isBottom ? {color: 'gray', cursor: 'not-allowed'} : {color: 'rgb(58, 135, 173)', cursor: 'pointer'}}
              onClick={this.onMoveDownGetsugakuSetting.bind(this, index)} /></span>
          </td>
        </tr>
      )
    })
    let toukyuuTable = []
    if (this.state.offset !== false) {
      const offset = this.state.offset
      const currentGetsugakuSetting = this.state.GetsugakuSettingInputData[offset]
      const startMonth = currentGetsugakuSetting.startMonth
      const endMonth = currentGetsugakuSetting.endMonth
      const toukyuuList = currentGetsugakuSetting.toukyuuList
      const toukyuuListToShow = toukyuuList.map((toukyuu, index, list) => {
        const isTop = (index === 0)
        const isBottom = (index === list.length - 1)
        const isOnlyOne = (list.length <= 1)
        return (
          <tr key={'toukyuuList_' + index}>
            <th className='kw-ds-no'>{index + 1}</th>
            <td><input type='text' value={toukyuu.kenkou} onChange={(e) => this.changeToukyuuData(offset, index, 'kenkou', e)} /></td>
            <td><input type='text' value={toukyuu.nenkin} onChange={(e) => this.changeToukyuuData(offset, index, 'nenkin', e)} /></td>
            <td><input type='text' value={toukyuu.izhou} onChange={(e) => this.changeToukyuuData(offset, index, 'izhou', e)} /></td>
            <td><input type='text' value={toukyuu.miman} onChange={(e) => this.changeToukyuuData(offset, index, 'miman', e)} /></td>
            <td className='kw-ds-gyou-sousa-icons'>
              <span className='text-success'><i className='icon-plus-sign kw-ds-txt-cursor' onClick={this.onInsertToukyuuList.bind(this, offset, index)} /></span>
              <span className='text-error'><i className='icon-minus-sign' onClick={this.onDeleteToukyuuList.bind(this, offset, index)}
                style={isOnlyOne ? {color: 'gray', cursor: 'not-allowed'} : {color: 'rgb(185, 74, 72)', cursor: 'pointer'}} /></span>
              <span className='text-info'><i className='icon-circle-arrow-up' style={isTop ? {color: 'gray', cursor: 'not-allowed'} : {color: 'rgb(58, 135, 173)', cursor: 'pointer'}}
                onClick={this.onMoveUpToukyuuList.bind(this, offset, index)} /></span>
              <span className='text-info'><i className='icon-circle-arrow-down' style={isBottom ? {color: 'gray', cursor: 'not-allowed'} : {color: 'rgb(58, 135, 173)', cursor: 'pointer'}}
                onClick={this.onMoveDownToukyuuList.bind(this, offset, index)} /></span>
            </td>
          </tr>
        )
      })
      toukyuuTable = (
        <div key={'toukyuuTable_' + offset}>
          <h5 className='alert alert-block alert-success'>【No.{offset + 1}】 :
          {Math.floor(startMonth / 100) + '年' + (startMonth % 100) + '月'} - {Math.floor(endMonth / 100) + '年' + (endMonth % 100) + '月'} の準報酬月額等級表 </h5>
          <table className='kw-ds-detail-tbl'>
            <thead>
              <tr>
                <th className='kw-ds-toukyuu' />
                <th className='kw-ds-kenkou' />
                <th className='kw-ds-nenkin' />
                <th className='kw-ds-izhou' />
                <th className='kw-ds-miman' />
                <th className='kw-ds-gyou-sousa' />
              </tr>
            </thead>
            <tbody>
              <tr>
                <th className='kw-ds-toukyuu'>等級<br />(健康保険)</th>
                <th>標準報酬月額<br />(健康保険)</th>
                <th>標準報酬月額<br />(厚生年金)</th>
                <th>以上</th>
                <th>未満</th>
                <th className='kw-ds-gyou-sousa'>行操作</th>
              </tr>
              {toukyuuListToShow}
            </tbody>
          </table>
        </div>
      )
    }
    return (
      <form id='userSecurityForm' className='form-horizontal' method='post' onSubmit={this.onSubmit.bind(this)}>
        <div className='row'>
          <fieldset className='kw-ds-regist-area span16'>
            <legend>標準報酬月額</legend>
            <div className='alert alert-block alert-info'>
              <p>
                必要な情報を入力して最後に「登録」ボタンを押してください。
              </p>
            </div>
            <table>
              <thead>
                <tr>
                  <th className='kw-ds-no' />
                  <th className='kw-ds-start-month' />
                  <th className='kw-ds-end-month' />
                  <th className='kw-ds-getsugaku' />
                  <th className='kw-ds-gyou-sousa' />
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th style={StyleAdmin.defaultSetting.textCenter}>No.</th>
                  <th className='kw-ds-start-month'>適用開始年月</th>
                  <th className='kw-ds-end-month'>適用終了年月</th>
                  <th style={StyleAdmin.defaultSetting.textCenter}>標準報酬月額</th>
                  <th style={StyleAdmin.defaultSetting.textCenter}>行操作</th>
                </tr>
                {getsugakuSettingToShow}
              </tbody>
            </table>
            {toukyuuTable}
            <footer id='submit-actions' className='form-actions'>
              <button id='submit-button' type='submit' className='btn btn-primary' name='action' value='CONFIRM'>登録</button>
            </footer>
          </fieldset>
        </div>
      </form>
    )
  }
}
export default GetsugakuSetting



// WEBPACK FOOTER //
// ./src/admin/pages/secure/DefaultSetting/GetsugakuSetting.js